export const debounce = (func: (...args: any[]) => void, delay: number) => {
	let timeoutId: ReturnType<typeof setTimeout>;
	return function (this: any, ...args: any[]) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => func.apply(this, args), delay) as any;
	};
};
